/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './close-account/index';
export * from './forgot-password/index';
export * from './register/index';
export * from './reset-password/index';
export * from './update-email/index';
export * from './update-password/index';
export * from './update-profile/index';
export * from './user-profile-components.module';
